<template>
    <div class="m-t-30 account-pages">
        <div class="text-center account-logo-box">
            <h4 class="text-uppercase font-bold m-t-0 m-b-20">Recuperar Senha</h4>
        </div>

        <div class="account-content" v-if="step == 'init'">
                <!-- <div class="alert alert-success">
                    Status message
                </div> -->
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group" v-bind:class="{'has-error': errors.has('input')}">
                        <p><b>Preencha o seu endereço de email ou número de celular no campo abaixo para recuperar sua senha.</b></p>
                        <input id="input" type="text" v-model="form.input"
                            class="form-control"
                            name="input"
                            v-validate="'required'"
                            placeholder="E-mail ou número de celular"
                            required />

                        <span class="help-block text-left" v-show="errors.has('input')">
                            <strong>{{ errors.first('input') }}</strong>
                        </span>

                        <span class="help-block text-left text-danger" v-show="user_not_found">
                            <strong>Não conseguimos localizar um usuário cadastrado com os dados acima. Tente novamente!</strong>
                        </span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <button type="button" @click="sendForm()" class="btn btn-success btn-block waves-effect waves-light m-t-20 ladda-button password-btn">
                        <span class="ladda-label">Enviar</span>
                    </button>
                </div>
            </div>
        </div>

        <reset-methods :cellphone="cellphone" :email="email" :full_email="full_email" v-if="step == 'methods'" @request_sent="requestSent"></reset-methods>
        <reset-sent v-if="step == 'sent'" :full_email="full_email" :cellphone="cellphone" :email="email" :method="method" @verified="tokenVerified"></reset-sent>
        <reset-newpass :token="token" :email="full_email" v-if="step == 'reset'"></reset-newpass>
    </div>
</template>

<script>
export default {
    props: ['ptoken', 'pemail'],
    data() {
        return {
            step: 'init',
            user_not_found: false,
            form: {
                input: ''
            },
            cellphone: '',
            email: '',
            full_email: this.pemail,
            method: null,
            token: this.ptoken
        }
    },
    methods: {
        tokenVerified(token) {
            this.token = token;
            this.step = 'reset';
        },
        requestSent(method) {
            this.method = method;
            this.step = 'sent';
        },
        sendForm() {
            this.user_not_found = false;
            this.$validator.validateAll().then(res => {
                if (!res)
                    return false;

                let l = Ladda.create( this.$el.querySelector('.ladda-button') );
                l.start();

                axios.post('/auth/password/detect', this.form).then(res => {
                    if (res.data.response) {
                        this.cellphone = res.data.cellphone;
                        this.email = res.data.email;
                        this.full_email = res.data.full_email;
                        this.step = 'methods';
                    } else {
                        this.user_not_found = true;
                    }
                }).finally(() => { l.stop() });
            });

        }
    },
    created() {
        this.$validator.localize('pt_BR', {
            messages: {
                required: 'Este campo é obrigatório!'
            },
        });

        if (this.ptoken.length > 0)
            this.step = 'reset';
    }
}
</script>

<style>
</style>
